import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import streamLineEmailSecurity from './../../assets/img/streamline-email-security.png';
import comprehensiveDomainOverview from './../../assets/img/comprehensive-domain-overview.png';
import detailViewForDeeperInsights from './../../assets/img/detail-view-for-deeper-insights.png';
import realtimeAlerting from './../../assets/img/realtime-alerting.jpg';
import singleSignOn from './../../assets/img/Single-Sign-On.png';
import {useTranslation} from "react-i18next";

const DmarcReporting = () => {
    const {t} = useTranslation();
    return (
        <Container className="my-5">
            <h1 className="text-center mb-4">{t('pages.dmarcReporting.title')}</h1>
            <p className="text-center mb-5">
                {t('pages.dmarcReporting.description')}
            </p>

            {/* Section 1 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <h2>{t("pages.dmarcReporting.sections.1.title")}</h2>
                    <p>
                        {t("pages.dmarcReporting.sections.1.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.dmarcReporting.sections.1.descriptions.2")}
                    </p>
                </Col>
                <Col md={6}>
                    <Image
                        src={streamLineEmailSecurity}
                        alt={t("pages.dmarcReporting.sections.1.image.alt")}
                        className={"img-fluid rounded shadow"}
                        fluid
                    />
                </Col>
            </Row>

            {/* Section 2 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <Image
                        src={comprehensiveDomainOverview}
                        alt={t("pages.dmarcReporting.sections.2.image.alt")}
                        className={"img-fluid rounded shadow"}
                        fluid
                    />
                </Col>
                <Col md={6}>
                    <h2>{t("pages.dmarcReporting.sections.2.title")}</h2>
                    <p>
                        {t("pages.dmarcReporting.sections.2.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.dmarcReporting.sections.2.descriptions.2")}
                    </p>
                </Col>
            </Row>

            {/* Section 3 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <h2>{t("pages.dmarcReporting.sections.3.title")}</h2>
                    <p>
                        {t("pages.dmarcReporting.sections.3.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.dmarcReporting.sections.3.descriptions.1")}                    </p>
                </Col>
                <Col md={6}>
                    <Image
                        src={detailViewForDeeperInsights}
                        alt={t("pages.dmarcReporting.sections.3.image.alt")}
                        fluid
                        className={"img-fluid rounded shadow"}
                    />
                </Col>
            </Row>

            {/* Section 4 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <Image
                        src={realtimeAlerting}
                        alt={t("pages.dmarcReporting.sections.4.image.alt")}
                        fluid
                        className={"img-fluid rounded shadow"}
                    />
                </Col>
                <Col md={6}>
                    <h2>{t("pages.dmarcReporting.sections.4.title")}</h2>
                    <p>
                        {t("pages.dmarcReporting.sections.4.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.dmarcReporting.sections.4.descriptions.2")}
                    </p>
                </Col>
            </Row>

            {/* Section 5 */}
            <Row className="align-items-center">
                <Col md={6}>
                    <h2>{t("pages.dmarcReporting.sections.5.title")}</h2>
                    <p>
                        {t("pages.dmarcReporting.sections.5.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.dmarcReporting.sections.5.descriptions.2")}
                    </p>
                </Col>
                <Col md={6}>
                    <Image
                        src={singleSignOn}
                        alt={t("pages.dmarcReporting.sections.5.image.alt")}
                        fluid
                        className={"img-fluid rounded"}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default DmarcReporting;
